<template>
  <div style="height: 100%">   
    <ExibirErrosConcept :errorsValidacao="errorsValidacao" ref="errosComponent"></ExibirErrosConcept>
     <vs-popup title="Contato" :active.sync="popUpFavorecidoContato.popupActive">
        <vs-alert color="danger" :active.sync="popUpFavorecidoContato.exibirMensagem" closable icon-pack="feather" close-icon="icon-x" class="mb-3" icon="icon-info">
                {{popUpFavorecidoContato.mensagem}}
        </vs-alert> 
        <div id="div3-with-loading" class="vs-con-loading__container">  
            <div class="vx-row">
                <div class="vx-col w-full">
                    <label class="vs-input--label">Nome</label>
                    <vs-input class="w-full" v-model="itemFavorecidoContato.nome" :maxlength="255"/>   
                </div>                
            </div>       
            <div class="vx-row mt-2">
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">E-mail</label>
                    <vs-input class="w-full" v-model="itemFavorecidoContato.email" :maxlength="255"/>   
                </div>                
                <div class="vx-col w-1/4">
                    <label class="vs-input--label">Financeiro ?</label>
                    <vs-checkbox class="w-full mt-2" v-model="itemFavorecidoContato.enviarEmailFinanceiro"/>   
                </div>           
                <div class="vx-col w-1/4" v-if="isConcept">
                    <label class="vs-input--label">Whatsapp ?</label>
                    <vs-checkbox class="w-full mt-2" v-model="itemFavorecidoContato.enviarWhatsappFinanceiro"/>   
                </div>           
            </div>       
            <div class="vx-row mt-2">
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Telefone Celular</label>
                    <vs-input class="w-full" v-model="itemFavorecidoContato.telefoneCelular" :maxlength="45"/>   
                </div>                
                <div class="vx-col w-1/2">
                    <label class="vs-input--label">Telefone Comercial</label>
                    <vs-input class="w-full" v-model="itemFavorecidoContato.telefoneComercial" :maxlength="45"/>   
                </div>                
            </div>       
            <div class="flex w-full mt-2">
                <vs-button class="ml-auto mt-2" size="small" color="success" @click="gravarFavorecidoContato">GRAVAR</vs-button>                                            
            </div>
        </div>
    </vs-popup>

    
    <vx-card>
        <div class="vx-row mb-4">
            <div class="vx-col md:w-1/2 w-full">                    
                <vs-button class="ml-auto mt-2" size="small" @click="gravar" color="success" v-if="temPermissaoAlterar">Gravar</vs-button>
                <vs-button class="ml-4 mt-2" size="small" @click="excluir" v-show="isDeletable && temPermissaoAlterar && isGestor" color="danger">Excluir</vs-button>            
                <vs-button class="ml-4 mt-2" size="small" type="border" color="dark" @click="voltar">Voltar</vs-button>             
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-1/4"><label class="vs-input--label">Fornecedor</label></div>                 
            <div class="vx-col w-1/4"><label class="vs-input--label">Cliente</label></div>     
            <div class="vx-col w-1/4" v-if="data_local.ehCliente"><label class="vs-input--label">Regra ISS</label></div>                 
            <div class="vx-col w-1/4" v-if="data_local.ehCliente"><label class="vs-input--label">Regra Emissão NF</label></div>                 
        </div>    
        <div class="vx-row">            
            <div class="vx-col w-1/4 flex">
                <vs-checkbox class="w-full" v-model="data_local.ehFornecedor"/>   
            </div> 
            <div class="vx-col w-1/4 flex">
                <vs-checkbox class="w-full" v-model="data_local.ehCliente"/>   
            </div>     
            <div class="vx-col w-1/4 flex" v-if="data_local.ehCliente">
                <v-select                                               
                    :options="CONSTANTE_OPCAO_REGRA_ISS" 
                    v-model="data_local.regraISS"    
                    :clearable="false"
                    :reduce="r => r.data"                                                                         
                    class="v-select w-full">
                </v-select>  
            </div>
            <div class="vx-col w-1/4 flex" v-if="data_local.ehCliente">
                <v-select                                               
                    :options="CONSTANTE_OPCAO_REGRA_EMISSAO_NF" 
                    v-model="data_local.regraEmissaoNotaFiscal"    
                    :clearable="false"
                    :reduce="r => r.data"                                                                         
                    class="v-select w-full">
                </v-select>  
            </div>

        </div>    
        <div class="vx-row mt-3">
            <div class="vx-col w-1/2"><label class="vs-input--label">Razão Social</label></div>     
            <div class="vx-col w-1/2"><label class="vs-input--label">Nome Fantasia</label></div>                 
        </div>    
        <div class="vx-row">
            <div class="vx-col w-1/2 flex">
                <vs-input class="w-full" v-model="data_local.razaoSocial" :maxlength="255"/>   
            </div>     
            <div class="vx-col w-1/2 flex">
                <vs-input class="w-full" v-model="data_local.nome" :maxlength="255"/>   
            </div>                 
        </div>    
        <div class="vx-row mt-3">
            <div class="vx-col w-1/2"><label class="vs-input--label">CNPJ</label></div>                             
            <div class="vx-col w-1/2"><label class="vs-input--label">E-mail</label></div>                             
        </div>    
        <div class="vx-row">
            <div class="vx-col w-1/2 flex">
                <vs-input class="w-full" v-model="data_local.cpfCNPJ" :maxlength="20"/>   
            </div>     
            <div class="vx-col w-1/2 flex">
                <vs-input class="w-full" v-model="data_local.email" :maxlength="255"/>   
            </div>                               
        </div>             
        <div class="vx-row mt-3">
            <div class="vx-col w-full"><label class="vs-input--label">Endereço</label></div>                                                     
        </div>                    
        <div class="vx-row">
            <div class="vx-col w-full flex">
                <vs-input class="w-full" v-model="data_local.endereco"/>   
            </div>                                 
        </div>   
        <div class="vx-row mt-3">
            <div class="vx-col w-1/4"><label class="vs-input--label">Número</label></div>                                         
            <div class="vx-col w-3/4"><label class="vs-input--label">Complemento</label></div>                                         
        </div>                    
        <div class="vx-row">
            <div class="vx-col w-1/4 flex">
                <vs-input class="w-full" v-model="data_local.numeroEndereco"/>   
            </div>                     
            <div class="vx-col w-3/4 flex">
                <vs-input class="w-full" v-model="data_local.complemento"/>   
            </div>                                 
        </div>
        <div class="vx-row mt-3">
            <div class="vx-col w-1/4"><label class="vs-input--label">CEP</label></div>     
            <div class="vx-col w-1/4"><label class="vs-input--label">Bairro</label></div>                                         
            <div class="vx-col w-1/4"><label class="vs-input--label">Cidade</label></div>                                         
            <div class="vx-col w-1/4"><label class="vs-input--label">Estado</label></div>                                         
        </div>    
        <div class="vx-row">
            <div class="vx-col w-1/4 flex">
                <vs-input class="w-full" v-model="data_local.cep" :maxlength="10"/>   
            </div>     
            <div class="vx-col w-1/4 flex">
                <vs-input class="w-full" v-model="data_local.bairro"/>   
            </div>     
            <div class="vx-col w-1/4 flex">
                <vs-input class="w-full" v-model="data_local.cidade"/>   
            </div>     
            <div class="vx-col w-1/4 flex">
                <v-select                                               
                    :options="CONSTANTE_UFS" 
                    v-model="data_local.estado"    
                    :clearable="false"
                    :reduce="r => r.data"     
                    style="z-index: 10000 !important;"                                                                    
                    class="v-select w-full">
                </v-select>  
            </div>     
        </div>   
        <div class="vx-row mt-3">
            <div class="vx-col w-1/3"><label class="vs-input--label">Telefone Comercial</label></div>                             
            <div class="vx-col w-1/3"><label class="vs-input--label">Telefone Celular</label></div>                             
            <div class="vx-col w-1/3"><label class="vs-input--label">Telefone Residencial</label></div>                             
        </div>    
        <div class="vx-row">
            <div class="vx-col w-1/3 flex">
                <vs-input class="w-full" v-model="data_local.telefoneComercial" :maxlength="20"/>   
            </div>     
            <div class="vx-col w-1/3 flex">
                <vs-input class="w-full" v-model="data_local.telefoneCelular" :maxlength="20"/>   
            </div>                               
            <div class="vx-col w-1/3 flex">
                <vs-input class="w-full" v-model="data_local.telefoneResidencial" :maxlength="20"/>   
            </div>                               
        </div>                  
    </vx-card>  
    
    <div id="div2-with-loading" class="vs-con-loading__container mt-4" v-if="this.data_local.hasOwnProperty('id')">
        <vx-card>
             <h6> Contatos </h6>
            <div class="flex mb-2 mt-2">
                <vs-button size="small" class="nowrap" icon="search" color="primary" @click="fecthListaFavorecidoContatos()"></vs-button>             
                <vs-button size="small" class="nowrap ml-2" icon="add" color="primary" @click="novoFavorecidoContato()" v-if="temPermissaoAlterar"></vs-button>             
            </div>
            <vs-table :data="listaFavorecidoContatos" noDataText="Nenhum Contato." stripe v-model="itemFavorecidoContato" @selected="editarFavorecidoContato">
                <template slot="thead">
                    <vs-th></vs-th>
                    <vs-th></vs-th>
                    <vs-th><small>Nome</small></vs-th>                                                                            
                    <vs-th><small>Celular</small></vs-th>                              
                    <vs-th><small>Comercial</small></vs-th>
                    <vs-th><small>Email</small></vs-th>      
                    <vs-th><small>Financeiro ?</small></vs-th>                    
                    <vs-th  v-if="isConcept"><small>Whatsapp ?</small></vs-th>                    
                    
                </template>
                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td>
                            <div class="btn-group flex">
                                <vs-button size="small" type="border" color="primary" icon-pack="feather" icon="icon-search"></vs-button>
                                <vs-button size="small" type="border" color="danger"  @click.stop="excluirFavorecidoContato(tr)" icon-pack="feather" icon="icon-trash" v-if="temPermissaoAlterar"></vs-button>            
                            </div>
                        </vs-td>
                        <vs-td :data="indextr">
                            <small>{{ (indextr + 1)}}</small>
                        </vs-td>
                        <vs-td :data="tr.nome"><small> {{ tr.nome }} </small></vs-td>
                        <vs-td :data="tr.telefoneCelular"><small> {{ tr.telefoneCelular }} </small></vs-td>
                        <vs-td :data="tr.telefoneComercial"><small> {{ tr.telefoneComercial }} </small></vs-td>
                        <vs-td :data="tr.email"><small> {{ tr.email }} </small></vs-td>                        
                        <vs-td :data="tr.enviarEmailFinanceiro"><small> {{ ( tr.enviarEmailFinanceiro ? 'X' : '')}} </small></vs-td>
                        <vs-td  v-if="isConcept" :data="tr.enviarWhatsappFinanceiro"><small> {{ ( tr.enviarWhatsappFinanceiro ? 'X' : '')}} </small></vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>
    </div>
  </div>
</template>

<script>
import generico from '@/generico.js'
import axios from "@/axios.js"
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue';
import { CONSTANTE_UFS } from '@/constantesComboBox.js'
import { CONSTANTE_OPCAO_REGRA_EMISSAO_NF } from '@/constantesComboBox.js'
import { CONSTANTE_OPCAO_REGRA_ISS } from '@/constantesComboBox.js'

const URL_SERVLET = "/Favorecido";
const NAME_ROUTE_SEARCH = "cadastro-favorecidos-pesquisar";

export default { 
  components: {  
    VueAutonumeric
  },      
  props: {
    registroOriginal: {
      type: Object,
      required: false,
      default: function () {
        return { ehFornecedor: false, ehCliente: false, codigo: null, nome: null, razaoSocial: null, cpfCNPJ: null, telefoneResidencial: null, 
            telefoneCelular: null, telefoneComercial: null, endereco:null, numeroEndereco:null, bairro:null, cep:null, cidade:null, estado:null, complemento:null, 
            email:null, regraEmissaoNotaFiscal: null, regraISS: null }
       }
    },
  },
  data() {
    return {        
        errorsValidacao: [],  
        data_local: JSON.parse(JSON.stringify(this.registroOriginal)), 
        listaFavorecidoContatos: [], 
        popUpFavorecidoContato :{
            popupActive: false,
            exibirMensagem: false,
            mensagem: null
        },
        itemFavorecidoContato :{ nome: null, email: null, telefoneComercial: null,  telefoneCelular: null, enviarEmailFinanceiro: false, enviarWhatsappFinanceiro: false }     
    }
  },  
  created(){
    this.CONSTANTE_UFS = CONSTANTE_UFS;
    this.CONSTANTE_OPCAO_REGRA_EMISSAO_NF = CONSTANTE_OPCAO_REGRA_EMISSAO_NF;
    this.CONSTANTE_OPCAO_REGRA_ISS = CONSTANTE_OPCAO_REGRA_ISS;
  }, 
  mounted() {
    if (this.registroOriginal.hasOwnProperty('id')) {
          this.$vs.loading();
          this.findById();  
    } 
  },
  computed: {        
    isConcept(){
        return this.$store.state.AppActiveUser.empresa.id === 1;
    },
    isDeletable() {
       return this.data_local != null && this.data_local.hasOwnProperty("id");
    }, 
    isGestor() {
      return (this.$store.state.AppActiveUser.perfil === 'GESTOR' || this.$store.state.AppActiveUser.perfil === 'GESTOR_EMPRESA');
    },
    temPermissaoAlterar() {
        if ( this.isGestor ) {
            return true;
        } 

        if (this.data_local !== null && this.data_local.hasOwnProperty("id")) {
            if (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO' || this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER' 
                    || this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_PAGAR' ) {
                return true;
            }

            return false;
        } else {
            if (this.$store.state.AppActiveUser.perfil === 'FINANCEIRO' || this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_RECEBER' 
                    || this.$store.state.AppActiveUser.perfil === 'FINANCEIRO_CONTA_PAGAR' || this.$store.state.AppActiveUser.perfil === 'CRM'
                    || this.$store.state.AppActiveUser.perfil === 'CRM_CONTA_RECEBER') {
                return true;
            }

            return false;
        }        
    }
  },
  methods: {  
    excluirFavorecidoContato(tr) {
        this.itemFavorecidoContato = tr;
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir o contato ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirFavorecidoContatoRequest
        });
    },
    excluirFavorecidoContatoRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('id', this.itemFavorecidoContato.id);   
        params.append('favorecido.id', this.data_local.id);   
                
        axios.post("/FavorecidoContato/RemoverFavorecidoContato", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.toUpperCase().indexOf('ERRO') != -1) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data, acceptText: 'OK'})
                } else {
                    this.$vs.notify({
                        title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                        text: response.data,
                    });
                    this.fecthListaFavorecidoContatos();
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - excluirRequest - " + error); 
        })  
    },   
    gravarFavorecidoContato() {     
        if (this.formularioFavorecidoContatoValido()) { 
            this.$vs.loading({
                container: '#div3-with-loading',
                scale: 0.6
            })
            const params = new URLSearchParams();  
            if (this.itemFavorecidoContato.hasOwnProperty('id')) {
                params.append('id', this.itemFavorecidoContato.id);   
            }
            params.append('favorecido.id', this.data_local.id);
            params.append('nome', this.itemFavorecidoContato.nome);   
            if (this.itemFavorecidoContato.email) {
                params.append('email', this.itemFavorecidoContato.email);   
            }
            if (this.itemFavorecidoContato.telefoneComercial) {
                params.append('telefoneComercial', this.itemFavorecidoContato.telefoneComercial);   
            }
            if (this.itemFavorecidoContato.telefoneCelular) {
                params.append('telefoneCelular', this.itemFavorecidoContato.telefoneCelular);   
            }
            params.append('enviarEmailFinanceiro', this.itemFavorecidoContato.enviarEmailFinanceiro);   
            params.append('enviarWhatsappFinanceiro', this.itemFavorecidoContato.enviarWhatsappFinanceiro);   
            
            
            axios.post("/FavorecidoContato/GravarFavorecidoContato", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                    
                    this.$vs.loading.close('#div3-with-loading > .con-vs-loading')
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.FavorecidoContato.erroOperacao) {                 
                        this.$vs.loading.close('#div3-with-loading > .con-vs-loading')       
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.mensagemResultadoOperacao, acceptText: 'OK'})
                    } else {                        
                         this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.FavorecidoContato.mensagemResultadoOperacao,
                        });

                        this.itemFavorecidoContato = response.data.FavorecidoContato;  
                        this.fecthListaFavorecidoContatos();
                        this.popUpFavorecidoContato.popupActive = false;
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }   
    },
    findByIdFavorecidoContato() {       
        this.$vs.loading({
            container: '#div3-with-loading',
            scale: 0.6
        })
        const params = new URLSearchParams();       
        params.append('id', this.itemFavorecidoContato.id);           
                
        axios.post("/FavorecidoContato/RecuperarFavorecidoContato", params, {              
            headers: {'Accept': 'application/json' }, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close('#div3-with-loading > .con-vs-loading')            
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                this.itemFavorecidoContato = response.data.FavorecidoContato;                          
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }, 
    novoFavorecidoContato() {  
        this.$vs.loading.close('#div3-with-loading > .con-vs-loading')            
        this.itemFavorecidoContato = { nome: null, email: null, telefoneComercial: null,  telefoneCelular: null, enviarEmailFinanceiro: false, enviarWhatsappFinanceiro: false } ;
        this.abrirPopUpFavorecidoContato();
    },
    editarFavorecidoContato() {  
        this.findByIdFavorecidoContato();
        this.abrirPopUpFavorecidoContato();
    },
    abrirPopUpFavorecidoContato() {  
        this.popUpFavorecidoContato.mensagem = null;
        this.popUpFavorecidoContato.popupActive = true;
    },
    fecthListaFavorecidoContatos(){       
      this.$vs.loading({
        container: '#div2-with-loading',
        scale: 0.6
      })
      
      const params = new URLSearchParams();      
      params.append('pagina',  -1);
      params.append('favorecido.id',  this.data_local.id);
                  
      axios.post("/FavorecidoContato/ListarFavorecidoContato", params, {              
              credentials: 'include',
              responseEncoding: 'iso88591',
              withCredentials: true } )
      .then((response) => {
          this.$vs.loading.close('#div2-with-loading > .con-vs-loading')
          if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
              this.$router.push({ path: '/login' });
          } else {              
              this.listaFavorecidoContatos = response.data.Resultado.lista;                            
          }
      })
      .catch((error) => { 
          this.$vs.loading.close('#div2-with-loading > .con-vs-loading')
          /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - fetchListaUnidadeOperacional - " + error); 
      })  
    },
    findById() {       
        const params = new URLSearchParams();       
        params.append('id', this.data_local.id);           
                
        axios.post(URL_SERVLET + "/RecuperarFavorecido", params, {              
            headers: {'Accept': 'application/json' }, credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            this.$vs.loading.close();           
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/login' });
            } else {                
                 this.data_local = response.data.Favorecido; 
                 this.fecthListaFavorecidoContatos();                
            }
        })
        .catch((error) => { 
            /* eslint-disable no-console */  console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    }, 
    excluir() {
        this.$vs.dialog({
          type: 'confirm', color: 'warning', title: 'Atenção', text: 'Deseja excluir ?', acceptText: 'Sim', cancelText: 'Não', accept: this.excluirRequest
        });
    },
    excluirRequest() {
        this.$vs.loading();  
        const params = new URLSearchParams();                
        params.append('listaIds', this.data_local.id);   
                
        axios.post(URL_SERVLET + "/RemoverFavorecido", params, {              
                credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
        .then((response) => {
            if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {
                this.$router.push({ path: '/' });
            } else {
                this.$vs.loading.close();
                if (response.data.hasOwnProperty("error")) {
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.error, acceptText: 'OK'})
                } else {
                    this.$router.push({ name: NAME_ROUTE_SEARCH })
                }                   
            }
        })
        .catch((error) => { 
            this.$vs.loading.close();
            /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
        })  
    },
    gravar() {        
        if (this.formularioValido()) { 
            this.$vs.loading();
            const params = new URLSearchParams();    
            
            if (this.data_local.hasOwnProperty('id')) {
                params.append('id', this.data_local.id);    
            }
            params.append('ehFornecedor', this.data_local.ehFornecedor);
            params.append('ehCliente', this.data_local.ehCliente);
            if (this.data_local.codigo) {
                params.append('codigo', this.data_local.codigo);
            }
            params.append('nome', this.data_local.nome);
            params.append('razaoSocial', this.data_local.razaoSocial);
            params.append('cpfCNPJ', this.data_local.cpfCNPJ);
            if (this.data_local.telefoneResidencial) {
                params.append('telefoneResidencial', this.data_local.telefoneResidencial);
            }
            if (this.data_local.telefoneCelular) {
                params.append('telefoneCelular', this.data_local.telefoneCelular);
            }
            if (this.data_local.telefoneComercial) {
                params.append('telefoneComercial', this.data_local.telefoneComercial);
            }
            params.append('endereco', this.data_local.endereco);
            params.append('numeroEndereco', this.data_local.numeroEndereco);
            params.append('bairro', this.data_local.bairro);
            params.append('cep', this.data_local.cep);
            params.append('cidade', this.data_local.cidade);
            params.append('estado', this.data_local.estado);
            if (this.data_local.complemento) {
                params.append('complemento', this.data_local.complemento);
            }

            params.append('email', this.data_local.email);
            if (this.data_local.ehCliente) {
                params.append('regraEmissaoNotaFiscal', this.data_local.regraEmissaoNotaFiscal);
                params.append('regraISS', this.data_local.regraISS);
            }

            axios.post(URL_SERVLET + "/GravarFavorecido", params, {              
                    credentials: 'include', responseEncoding: 'iso88591', withCredentials: true } )
            .then((response) => {
                
                if (response.data.hasOwnProperty("codigo") && response.data.codigo === "99" ) {                    
                    this.$vs.loading.close();
                    this.$router.push({ path: '/' });
                } else {                    
                    if (response.data.Favorecido.erroOperacao) {                 
                        this.$vs.loading.close();
                        this.$vs.dialog({ color: 'danger', title: 'Erro', text: response.data.Favorecido.mensagemResultadoOperacao, acceptText: 'OK'})
                    } else {                        
                         this.$vs.notify({
                            title: "Mensagem", iconPack: 'feather', icon: 'icon-info', color: 'success',
                            text: response.data.Favorecido.mensagemResultadoOperacao,
                        });

                        this.data_local = response.data.Favorecido;  
                        this.findById();
                    }                   
                }
            })
            .catch((error) => { 
                this.$vs.loading.close();
                /* eslint-disable no-console */ console.log("EFETUAR LOGOFF! - gravar - " + error); 
            })  
        }         
    },
    voltar() {
        this.$router.push({
            name: NAME_ROUTE_SEARCH                     
        })
    },
    formularioValido() {
        this.$refs.errosComponent.iniciar();
        this.errorsValidacao = [];
      
        if (!this.data_local.ehCliente && !this.data_local.ehFornecedor) { this.errorsValidacao.push("Informe se é um cliente e/ou fornecedor"); }
        if (!this.data_local.nome) { this.errorsValidacao.push("Nome obrigatório"); }
        if (!this.data_local.razaoSocial) { this.errorsValidacao.push("Razão Social obrigatório"); }
        if (!this.data_local.cpfCNPJ) { this.errorsValidacao.push("CPF/CNPJ obrigatório"); }

        if (this.data_local.cpfCNPJ && !generico.isCNPJValido(this.data_local.cpfCNPJ) && !generico.isCPFValido(this.data_local.cpfCNPJ)) {
            this.errorsValidacao.push("CPF/CNPJ inválido.");
        }

        if (!this.data_local.telefoneComercial && !this.data_local.telefoneCelular && !this.data_local.telefoneResidencial) { this.errorsValidacao.push("Informe pelo menos um telefone"); }
        if (!this.data_local.endereco) { this.errorsValidacao.push("Endereço obrigatório"); }
        if (!this.data_local.numeroEndereco) { this.errorsValidacao.push("Número do Endereço obrigatório"); }
        if (!this.data_local.bairro) { this.errorsValidacao.push("Bairro obrigatório"); }
        if (!this.data_local.cidade) { this.errorsValidacao.push("Cidade obrigatório"); }
        if (!this.data_local.estado) { this.errorsValidacao.push("Estado obrigatório"); }
        if (!this.data_local.cep) { this.errorsValidacao.push("CEP obrigatório"); } 
        else if (!generico.isCEPValido(this.data_local.cep)) { this.errorsValidacao.push("CEP inváido. Digite o CEP no formato XXXXX-XXX"); }
        if (!this.data_local.email) { this.errorsValidacao.push("Email obrigatório"); }
        
        if (this.data_local.ehCliente) {
            if (!this.data_local.regraISS) { this.errorsValidacao.push("Regra de ISS obrigatório"); }
            if (!this.data_local.regraEmissaoNotaFiscal) { this.errorsValidacao.push("Regra emissão de Nota Fiscal obrigatório"); }

        }

        if (!this.errorsValidacao.length) {
            return true;
        }   
        return false;
    },
    formularioFavorecidoContatoValido() {        
        if (!this.itemFavorecidoContato.nome) { 
            this.popUpFavorecidoContato.mensagem = "Informe o nome do contato.";
            this.popUpFavorecidoContato.exibirMensagem = true;
            return false;
        }

        if (!this.itemFavorecidoContato.email && !this.itemFavorecidoContato.telefoneCelular && !this.itemFavorecidoContato.telefoneComercial) { 
            this.popUpFavorecidoContato.mensagem = "Informe pelo pelo menos um dos campos ( email, telefone celular ou telefone comercial )";
            this.popUpFavorecidoContato.exibirMensagem = true;
            return false;
        }

        if (this.itemFavorecidoContato.email && generico.emailInvalido(this.itemFavorecidoContato.email)) {
            this.popUpFavorecidoContato.mensagem = "Email inválido.";
            this.popUpFavorecidoContato.exibirMensagem = true;
            return false;
        }
        
        return true;
    },
  }
}
</script>

<style scoped>  
  .vs__dropdown-menu {
    max-height: 80px;    
  }
</style>

<style scoped>
  .tabelaComScroll {      
      overflow: auto;  
      height: calc(100vh - 300px);
      position: relative;      
    } 
</style>